import { defineMessages } from 'react-intl';

export const physicalCardFormMessages = defineMessages({
    usePreviousAddress: {
        id: 'forms.giftcard.usePreviousAddress',
        description: 'Use previous address toggle label',
        defaultMessage: 'Use previous address?'
    },
    expectAGift: {
        id: 'forms.giftcard.expectAGift',
        description: 'Expect a gift checkbox label',
        defaultMessage: 'Tell them to expect a gift?'
    },
});

export const personalizationFormMessages = defineMessages({
    forMe: {
        id: 'forms.giftcard.forMe',
        description: 'For me button text',
        defaultMessage: '{deliveryMethod, select, DIGITAL {For} PHYSICAL {To}} Me'
    },
    forAFriend: {
        id: 'forms.giftcard.forAFriend',
        description: 'For a friend button text',
        defaultMessage: '{deliveryMethod, select, DIGITAL {For a} PHYSICAL {To a}} Friend'
    },
    addToCartButtonText: {
        id: 'forms.giftcard.addToCartButtonText',
        description: 'Add to cart button text',
        defaultMessage: 'Add to Cart'
    },
    saveChangesButtonText: {
        id: 'forms.giftcard.saveChangesButtonText',
        description: 'Save changes button text',
        defaultMessage: 'Save Changes'
    },
    personalizationHeader: {
        id: 'forms.giftcard.personalizationMessage',
        description: 'Gift card personalization header',
        defaultMessage: 'Buy {precedingArticle} {activeProductName}'
    },
    whoForHeader: {
        id: 'forms.giftcard.whoForHeader',
        description: 'Whos it for section header',
        defaultMessage: "Who's it for?"
    },
    wheresItGoingHeader: {
        id: 'forms.giftcard.wheresItGoingHeader',
        description: 'Wheres it going section header',
        defaultMessage: "Where's it Going?"
    },
    slideDownDescriptionLabel: {
        id: 'forms.giftcard.slideDownDescriptionLabel',
        description: 'Product description label',
        defaultMessage: 'Description'
    },
    slideDownTermsAndConditionsLabel: {
        id: 'forms.giftcard.slideDownTermsAndConditionsLabel',
        description: 'Terms and conditions label',
        defaultMessage: 'Details'
    },
    slideDownRedemptionDetailsLabel: {
        id: 'forms.giftcard.slideDownRedemptionDetailsLabel',
        description: 'Redemption instructions label',
        defaultMessage: 'Redemption Instructions'
    },
    eGiftTabName: {
        id: 'forms.giftcard.eGiftTabName',
        description: 'eGift tab label',
        defaultMessage: 'eGift'
    },
    physicalTabName: {
        id: 'forms.giftcard.physicalTabName',
        description: 'Physical tab label',
        defaultMessage: 'Physical'
    },
    deliveryMethodLabel: {
        id: 'forms.giftcard.deliveryMethodLabel',
        description: 'Delivery method label',
        defaultMessage: 'Type of card'
    },
    feeAmountText: {
        id: 'forms.giftcard.feeAmountText',
        description: 'The fee amount label',
        defaultMessage: 'This card has a purchase fee of ${feeAmount}'
    },
});
